import { createSlice } from '@reduxjs/toolkit';
import { createSelectors } from './selectors';
const embeddedFormNS = 'embeddedForms';
const selectState = state => state[embeddedFormNS];

const initialState = {
  businessClients: {}, // keep adding the forms that you need as embedded forms
  customers: {},
  sites: {},
  assetTypes: {},
};

export const embeddedForms = createSlice({
  name: embeddedFormNS,
  initialState,
  reducers: {
    setEmbeddedFormDetails: (state, { payload }) => {
      const { formType } = payload;
      state[formType] = payload.details;
    },
    clearEmbeddedFormDetails: state => {
      state.businessClients = {}; // clear other states when added in initial state
      state.customers = {}; // clear other states when added in initial state
      state.sites = {};
      state.assetTypes = {};
    },
  },
});

export const { actions, reducer } = embeddedForms;

export { embeddedFormNS };

export const selectors = createSelectors(selectState);
